import React, { FC } from "react";
import { Icon } from "@mui/material";
import "./Icons.scss";
import { IconProps } from "./types";
import cx from "classnames";

export const Icons: FC<IconProps> = ({
  name = "search",
  size = "small",
  className = "",
  style = {},
  color,
  onClick
}) => {
  
  return (
    <>
      <Icon
        className={cx("icons-gtc-rc", className)}
        sx={{ ...style, color: color ? color : "inherit" }}
        fontSize={size}
        onClick={onClick}
      >
        {name}
      </Icon>
    </>
  );
};
